export default __webpack_public_path__ + "static/media/session-switch-hover.a1f83bdc.svg";